// extracted by mini-css-extract-plugin
export default {"root":"root--HS01A"};